import { addAsync as _addAsync } from "../api";

const BASE_URL = "/conversations/client-access-token";

export async function createAccessTokenAsync({ identity }) {
    return _addAsync({ url: BASE_URL, data: { identity } });
}
